import { MutationTree } from 'vuex';
import { iReview } from '@/entities/review/review.types';
import { FeedState } from '../../types/feed-module.types';

export enum FEED_MUTATIONS {
  SET_REVIEWS = 'SET_REVIEWS',
  APPEND_REVIEWS = 'APPEND_REVIEWS',
}

export const mutations: MutationTree<FeedState> = {
  [FEED_MUTATIONS.SET_REVIEWS](state, value: iReview[]) {
    state.reviews = value;
  },
  [FEED_MUTATIONS.APPEND_REVIEWS](state, value: iReview[]) {
    state.reviews.push(...value);
  },
};
